import { cn } from "@borderless/ui/lib/utils";
import type { FC } from "react";

export const ThreeGridLayout: FC<{
  left: React.ReactNode;
  center: React.ReactNode;
  right: React.ReactNode;
  className?: string;
}> = (props) => {
  return (
    <div
      className={cn(
        "mx-auto flex w-full max-w-[80rem] flex-col gap-8 bg-background xl:flex-row",
        props.className,
      )}
    >
      <div className="shrink-0 px-4 xl:sticky xl:top-[calc(var(--header-height)+var(--main-padding))] xl:block xl:max-h-[calc(100dvh-var(--header-height)-var(--main-padding))] xl:w-56 xl:overflow-auto xl:pb-(--main-padding)">
        {props.left}
      </div>
      <div className="grow px-4">{props.center}</div>
      <div className="flex shrink-0 flex-col gap-8 overflow-auto px-4 xl:w-80">
        {props.right}
      </div>
    </div>
  );
};
